import { TRouterLink } from "@/models/router";
import { RouteConfig } from "vue-router";
import { RExpertTemplateActivityLog } from "@/modules/Services/Template/views/ActivityLog/RTemplateActivityLog";
import { RExpertTemplateCoverLetter } from "@/modules/Services/Template/views/CoverLetter/RTemplateCoverLetter";
import { RExpertDataHistory } from "@/modules/Services/Template/views/DataHistory/RDataHistory";
import {
  RCandidateTemplateDashboard,
  RExpertTemplateDashboard,
} from "@/modules/Services/Template/views/Summary/RTemplateDashboard";
import {
  RCandidateTemplateProfile,
  RExpertTemplateProfile,
} from "@/modules/Services/Template/views/Profile/RTemplateProfile";
import {
  RCandidateTemplateDocuments,
  RExpertTemplateDocuments,
} from "@/modules/Services/Template/views/Documents/RTemplateDocuments";
import {
  RCandidateTemplateOnlineApplication,
  RExpertTemplateOnlineApplication,
} from "@/modules/Services/Template/views/OnlineApplication/RTemplateOnlineApplication";
import {
  RCandidateTemplateReport,
  RExpertTemplateReport,
} from "@/modules/Services/Template/views/Report/RTemplateReport";

import { RExpertHOEmail } from "@/modules/Services/Template/views/HOEmail/RHOEmail";

import { REmployerCandidates } from "@/modules/Services/Template/views/Candidates/REmployerCandidates";

export const RExpertServicesTemplate: RouteConfig = {
  path: ":id(\\d+)",
  name: "expertDashboard",
  component: () =>
    import(
      /* webpackChunkName: "expert-cases-template" */
      "./VServicesTemplate.vue"
    ),
  meta: {
    backLink: "/expert/cases",
    title: "Cases",
  },
  children: [
    RExpertTemplateDocuments,
    RExpertTemplateOnlineApplication,
    RExpertTemplateProfile,
    RExpertTemplateDashboard,
    RExpertTemplateActivityLog,
    RExpertTemplateCoverLetter,
    RExpertTemplateReport,
    RExpertDataHistory,
    RExpertHOEmail,
    REmployerCandidates,
  ],
};

export const expertTemplateLinks = (RExpertServicesTemplate.children ?? []).reduce(
  (items, { path, meta }) =>
    meta?.label
      ? items.concat({
          path: `/${path}`,
          label: meta.label,
          basePath: meta.basePath,
        })
      : items,
  [] as TRouterLink[]
);

export const RCandidateServicesTemplate: RouteConfig = {
  name: "CandidateService",
  path: ":id(\\d+)",
  component: () =>
    import(
      /* webpackChunkName: "candidate-cases-template" */
      "./VServicesTemplate.vue"
    ),
  meta: {
    backLink: "/cases",
    title: "Cases",
  },
  children: [
    RCandidateTemplateDashboard,
    RCandidateTemplateProfile,
    RCandidateTemplateDocuments,
    RCandidateTemplateOnlineApplication,
    RCandidateTemplateReport,
    REmployerCandidates,
  ],
};

export const candidateTemplateLinks = (RCandidateServicesTemplate.children ?? []).reduce(
  (items, { path, meta }) =>
    meta?.label
      ? items.concat({
          path: `/${path}`,
          label: meta.label,
          basePath: meta.basePath,
        })
      : items,
  [] as TRouterLink[]
);
